// @ts-nocheck
/* ============================================================
   PRODUCT INQUIRY MODAL
   CleanSecret theme custom feature
   ============================================================ */

(function () {
  'use strict';

  /* ── Modal open / close ───────────────────────────────────── */

  function openModal(productTitle, productUrl) {
    var overlay = document.getElementById('inquiry-modal-overlay');
    if (!overlay) return;

    var messageField = overlay.querySelector('#inquiry-message');
    if (messageField && !messageField.dataset.userEdited) {
      messageField.value =
        'Nor\u0117\u010diau gauti daugiau informacijos apie \u0161i\u0105 prek\u0119:\n\n' +
        'Prek\u0117: ' + (productTitle || '') + '\n' +
        'Nuoroda: ' + (productUrl || window.location.href);
    }

    var productNameEl = overlay.querySelector('.inquiry-modal__product-name');
    if (productNameEl) {
      productNameEl.textContent = productTitle || '';
    }

    var successEl = overlay.querySelector('.inquiry-modal__success');
    var formEl = overlay.querySelector('.inquiry-modal__form');
    if (successEl) successEl.classList.remove('is-visible');
    if (formEl) formEl.classList.remove('is-hidden');

    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var firstInput = overlay.querySelector('input[name="contact[name]"]');
    if (firstInput) {
      setTimeout(function () { firstInput.focus(); }, 80);
    }
  }

  function closeModal() {
    var overlay = document.getElementById('inquiry-modal-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    var messageField = overlay.querySelector('#inquiry-message');
    if (messageField) delete messageField.dataset.userEdited;
  }

  /* ── Button handler ───────────────────────────────────────── */

  function handleInquiryClick() {
    var title = this.dataset.productTitle || document.title;
    var url = this.dataset.productUrl || window.location.href;
    openModal(title, url);
  }

  function attachInquiryButtons() {
    document.querySelectorAll('.inquiry-btn').forEach(function (btn) {
      btn.removeEventListener('click', handleInquiryClick);
      btn.addEventListener('click', handleInquiryClick);
    });
  }

  /* ── Init ─────────────────────────────────────────────────── */

  function init() {
    var overlay = document.getElementById('inquiry-modal-overlay');
    if (!overlay) return;

    /* Close on backdrop click */
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    /* Close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeModal();
      }
    });

    /* Close button inside modal */
    var closeBtn = overlay.querySelector('.inquiry-modal__close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    /* Success state close button */
    var successCloseBtn = overlay.querySelector('.inquiry-modal__success-close');
    if (successCloseBtn) successCloseBtn.addEventListener('click', closeModal);

    /* Track user edits to message so we don't overwrite on reopen */
    var messageField = overlay.querySelector('#inquiry-message');
    if (messageField) {
      messageField.addEventListener('input', function () {
        this.dataset.userEdited = 'true';
      });
    }

    /* Auto-open if form was just posted (Shopify redirect back to page) */
    var successEl = overlay.querySelector('.inquiry-modal__success');
    if (successEl && successEl.classList.contains('is-visible')) {
      var formEl = overlay.querySelector('.inquiry-modal__form');
      if (formEl) formEl.classList.add('is-hidden');
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    attachInquiryButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', attachInquiryButtons);

  /* Expose for external use */
  window.ProductInquiry = { open: openModal, close: closeModal };
})();
